import { useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import { PaymentOrderDescription } from 'core/payments/entities';
import { useResignPayment } from 'core/payments/hooks';
import PaymentResignForm, { PaymentResignFormProps } from '../PaymentResignForm';

type PaymentResignProps = {
  onSuccess?: (data: { order?: PaymentOrderDescription }) => void;
  onSubmit?: () => void;
  className?: string;
  submitButtonText?: string;
  formProps?: Pick<PaymentResignFormProps, 'appearance' | 'styles'>;
};

const PaymentResign = ({
  onSuccess: passedOnSuccess,
  onSubmit,
  className,
  submitButtonText,
  formProps = {},
}: PaymentResignProps) => {
  const { appearance: passedFormAppearance = {}, styles: passedFormStyles = {} } = formProps;

  const { palette } = useTheme();
  const { resignFormData, resignFormSucceed, resignFormFailed } = useResignPayment();

  const onSuccess = useCallback(
    (data: { order: PaymentOrderDescription }) => {
      resignFormSucceed();

      if (passedOnSuccess) {
        passedOnSuccess(data);
      }
    },
    [passedOnSuccess, resignFormSucceed],
  );

  if (!resignFormData) {
    return null;
  }

  const formStyles: PaymentResignFormProps['styles'] = {
    'resign-submit-button': {
      'border-radius': '30px',
      height: '44px',
      'text-transform': 'none',
      padding: '10px 25px',
      'background-color': palette.payment.submitButton,

      '.title-icon': {
        display: 'none',
      },
    },
    ...passedFormStyles,
  };

  const formAppearance: PaymentResignFormProps['appearance'] = {
    submitButtonText,
    googleFontLink: 'https://fonts.googleapis.com/css2?family=Open+Sans&display=swap',
    ...passedFormAppearance,
  };

  return (
    <PaymentResignForm
      className={className}
      resignRequest={resignFormData}
      onSuccess={onSuccess}
      onSubmit={onSubmit}
      onFail={resignFormFailed}
      onError={resignFormFailed}
      styles={formStyles}
      appearance={formAppearance}
    />
  );
};

export default PaymentResign;
